import { SendChatMessageInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const SendChatMessageInputSchema: z.ZodType<SendChatMessageInput> =
  z.object({
    appointment_chat_id: z.number().int().positive(),
    message: z.string().min(1),
  });
